import { render, staticRenderFns } from "./CardContent.vue?vue&type=template&id=22d6c02f&scoped=true&"
import script from "./CardContent.vue?vue&type=script&lang=js&"
export * from "./CardContent.vue?vue&type=script&lang=js&"
import style0 from "./CardContent.vue?vue&type=style&index=0&id=22d6c02f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d6c02f",
  null
  
)

export default component.exports